import { SvgBase } from "../svg.base";

export const Reload = () => (
  <SvgBase
    width="16"
    height="22"
    viewBox="0 0 16 22"
  >
    <path
      fill="currentColor"
      d="M8 17a6 6 0 0 1-6-6c0-1 .25-1.97.7-2.8L1.24 6.74A7.93 7.93 0 0 0 0 11a8 8 0 0 0 8 8v3l4-4-4-4v3zM8 3V0L4 4l4 4V5a6 6 0 0 1 6 6c0 1-.25 1.97-.7 2.8l1.46 1.46A7.93 7.93 0 0 0 16 11a8 8 0 0 0-8-8z"
    />

  </SvgBase>
);